import {DocumentDTO} from '../../api/data-contracts'
import BootstrapTable, {ColumnDescription} from 'react-bootstrap-table-next'
import _ from 'lodash'
import {useSelector} from 'react-redux'
import {getDocumentState} from '../../redux/documentSlice'
import moment from 'moment'
import DocumentOpenButton from './DocumentOpenButton'
import DocumentDeleteButton from './DocumentDeleteButton'
import DocumentApprovalButtons from './DocumentApprovalButtons'
import DocumentApprovalStatus from './DocumentApprovalStatus'
import clsx from 'clsx'
import FileUploadButton from './FileUploadButton'
import {FileApprovalStatusEnum} from '../../apiClient/enums'
import DocumentReuploadButton from './DocumentReuploadButton'

function FilesTable() {
  const documentState = useSelector(getDocumentState)

  const headerName = documentState.selectedFolder
    ? (documentState.selectedFolder?.name ?? '') + ' Dosyaları'
    : 'Dosyalar'

  const columns: ColumnDescription[] = [
    {
      dataField: 'guid',
      text: headerName,
      sort: true,
      headerStyle: {width: '55%'},
      classes: 'fs-4',
      formatter: (cell: any, row: DocumentDTO, rowIndex: number, colIndex: number) => (
        <div className='d-flex align-items-center h-100 mt-1'>
          <div
            className={clsx('h-100', {
              required: row.isDownloaded === false,
            })}
          >
            {row.fileName}
          </div>
          {/* <FilePreview imageUrl={row.uri ?? ''} extension={row.extension ?? ''} /> */}
        </div>
      ),
    },
    {
      dataField: 'state',
      text: 'Durum',
      sort: true,
      headerClasses: 'text-center',
      headerStyle: {width: '10%'},
      classes: 'pt-4',
      formatter: (cell: any, row: DocumentDTO, rowIndex: number, colIndex: number) => (
        <DocumentApprovalStatus document={row} />
      ),
    },
    {
      dataField: 'lastModified',
      text: 'Tarih',
      sort: true,
      classes: 'fs-4',
      headerClasses: 'text-center',
      headerStyle: {width: '15%'},
      formatter: (cell: any, row: DocumentDTO, rowIndex: number, colIndex: number) => (
        <div className='text-center'>
          {row.uploadDate && moment(row.uploadDate).format('DD.MM.yyyy HH:mm')}
        </div>
      ),
    },
    {
      dataField: 'state2',
      text: 'Onay',
      sort: true,
      headerStyle: {width: '8%'},
      headerClasses: 'text-center',
      formatter: (cell: any, row: DocumentDTO, rowIndex: number, colIndex: number) => (
        <DocumentApprovalButtons document={row} />
      ),
    },
    {
      dataField: 'description',
      text: 'İşlemler',
      sort: true,
      headerClasses: 'text-center',
      classes: 'fs-8',
      headerStyle: {width: '12%'},
      formatter: (cell: any, row: DocumentDTO, rowIndex: number, colIndex: number) => (
        <>
          <div className='d-flex flex-row'>
            <div className='ms-1'>
              <DocumentOpenButton file={row} />
            </div>
            <div className='ms-2'>
              {row.approvalStatusId !== FileApprovalStatusEnum.Onaylandı && (
                <DocumentReuploadButton guidId={row.guid ?? ''} />
              )}
            </div>
            <div className='ms-2'>
              {row.approvalStatusId !== FileApprovalStatusEnum.Onaylandı && (
                <DocumentDeleteButton documentId={row.guid ?? ''} />
              )}
            </div>
          </div>
        </>
      ),
    },
  ]

  return (
    <div className='table-responsive'>
      <>
        <div>
          <BootstrapTable
            keyField='guid'
            data={_.orderBy(documentState.documents, (o) => o.fileName, 'asc') ?? []}
            columns={columns}
            classes='table table-rounded table-hover border gy-2 gs-7'
            rowClasses={'border border-gray-200'}
            headerClasses='fw-bold fs-6 text-gray-800 border-bottom border-gray-200 bg-info bg-opacity-50'
          />
        </div>
        <div className='text-center'>
          {documentState.selectedFolder && documentState.selectedFolder.canUpload && (
            <FileUploadButton />
          )}
        </div>
      </>
    </div>
  )
}

export default FilesTable
